import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color", "margin", "stroke", "width", "className", "style"];
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Core } from "@faire/design-tokens";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import cn from "classnames";
import React from "react";
import * as styles from "./styles.css";
/**
 * @trackcomponent
 */
export var HorizontalLine = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var color = _ref.color,
    margin = _ref.margin,
    stroke = _ref.stroke,
    width = _ref.width,
    classNameProp = _ref.className,
    styleProp = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded);
  var inlineSizeVar = width != null ? styles.inlineSizeVar : null;
  var marginVar = margin != null ? styles.marginVar : null;
  var blockSizeVar = stroke != null ? styles.blockSizeVar : null;
  var blockStartVar = stroke != null || color != null ? styles.borderBlockStartVar : null;
  var backgroundColorVar = color != null ? styles.backgroundColorVar : null;
  var legacyColorStyles = undefined;
  if (backgroundColorVar) {
    legacyColorStyles = {
      // In the previous implementation we passed in
      // color={color} which Chrome used to set a background
      // and border color. We only do this if a color is passed.
      backgroundColor: backgroundColorVar,
      borderColor: backgroundColorVar,
      borderStyle: "solid"
    };
  }
  return /*#__PURE__*/React.createElement("hr", _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    style: _objectSpread(_objectSpread({}, assignInlineVars(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles.inlineSizeVar, width != null ? width : null), styles.marginVar, margin != null ? margin : null), styles.blockSizeVar, stroke != null ? stroke : null), styles.borderBlockStartVar, stroke != null || color != null ? "".concat(stroke || "1px", " solid ").concat(color ? color : Core.border.muted) : null), styles.backgroundColorVar, color))), styleProp),
    className: cn(classNameProp, styles.base, styles.sprinkles(_objectSpread({
      inlineSize: inlineSizeVar !== null && inlineSizeVar !== void 0 ? inlineSizeVar : "100%",
      margin: marginVar !== null && marginVar !== void 0 ? marginVar : 0,
      blockSize: blockSizeVar !== null && blockSizeVar !== void 0 ? blockSizeVar : 1,
      borderBlockStart: blockStartVar !== null && blockStartVar !== void 0 ? blockStartVar : styles.defaultBlockStart
    }, legacyColorStyles)))
  }));
});